import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { GetRealtimeBalanceRequest, GetRealtimeBalanceResponse } from '../../interface/CustomerRecharge';
import { ApiResponse } from '../../api/api';
import customerRechargeService from '../../services/customerRechargeService';

export type GetRealtimeBalanceWithSignal = GetRealtimeBalanceRequest & { signal?: AbortSignal };

export const fetchRealtimeBalance = createAsyncThunk<
  ApiResponse<GetRealtimeBalanceResponse>,
  GetRealtimeBalanceWithSignal,
  { rejectValue: string }
>(
  'realtimeBalance/fetchRealtimeBalance',
  async (request, { rejectWithValue }) => {
    try {
      return await customerRechargeService.getRealtimeBalance(request, request.signal);
    } catch (error) {
      return rejectWithValue(error as any);
    }
  }
);

export interface FetchRealtimeBalanceState {
  realtimeBalance: ApiResponse<GetRealtimeBalanceResponse> | null;
  loading: boolean;
  error: string | null;
}

const initialState: FetchRealtimeBalanceState = {
  realtimeBalance: null,
  loading: false,
  error: null,
};

const fetchRealtimeBalanceSlice = createSlice({
  name: 'fetchRealtimeBalance',
  initialState,
  reducers: {
    resetRealtimeBalance: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRealtimeBalance.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRealtimeBalance.fulfilled, (state, action) => {
        state.loading = false;
        state.realtimeBalance = action.payload;
      })
      .addCase(fetchRealtimeBalance.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || null;
        state.realtimeBalance = null;
      });
  },
});

export const { resetRealtimeBalance } = fetchRealtimeBalanceSlice.actions;
export default fetchRealtimeBalanceSlice.reducer;
